import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDDialogTitle, FDHeadlineText, FDTitleText,
} from '@facet-wealth/design';
import { AutoCompleteInputLarge, TextInputLarge } from 'Packages/FacetDesign/Components';
import { RadioGroupInput } from 'Packages/FacetDesign/Components/RadioGroupInput';

export const JustWinMetaOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['wontSendOpenTasksDetails', 'noHelpReasonDetails', 'noMeetingReason'],
    {
      _component: () => TextInputLarge,
      _customProps: {
        rows: 5,
      },
    })
  .nameOverride('subtitle', { _component: () => FDTitleText }, overrideReadOnly)
  .nameOverride('description', { _component: () => FDBodyText }, overrideReadOnly)
  .nameOverride('directIndexingAlternativeIncomeSubtitle', { _component: () => FDTitleText }, overrideReadOnly)
  .nameOverride('excludeFromCampaignReasonDetails',
    {
      _component: () => TextInputLarge,
      _customProps: {
        rows: 3,
      },
    })
  .override({ name: 'rejectedDirectIndexTickersForPersonalReasons', readonly: false }, {
    _component: () => AutoCompleteInputLarge,
    _customProps: {
      multiple: true,
      fullWidth: true,
      helperText: '',
    },
  }, overrideReadOnly)
  .override({ name: 'rejectedDirectIndexTickersForComplianceReasons', readonly: false }, {
    _component: () => AutoCompleteInputLarge,
    _customProps: {
      multiple: true,
      fullWidth: true,
      helperText: '',
    },
  }, overrideReadOnly)
  .override({ name: 'rejectedDirectIndexTickersForPersonalReasons', readonly: true }, { _component: () => TextInputLarge }, overrideReadOnly)
  .override({ name: 'rejectedDirectIndexTickersForComplianceReasons', readonly: true }, { _component: () => TextInputLarge }, overrideReadOnly)
  .override({ name: 'willSendOpenAndFundActions', readonly: false }, { _component: () => RadioGroupInput }, overrideReadOnly)
  .override({ name: 'helpedMember', readonly: false }, { _component: () => RadioGroupInput }, overrideReadOnly)
  .override({ name: 'bookedMxIsMeeting', readonly: false }, { _component: () => RadioGroupInput }, overrideReadOnly);

// JustWinDialogWithLegacyFieldsHiddenMetaOverride hides legacy fields that are included for backwards compatibility. They are omitempty on the server
// but this is here to further guarantee that they won't show up where we don't want them
export const JustWinDialogMetaOverride = JustWinMetaOverride
  .nameOverride('title', {
    _component: () => FDDialogTitle,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride([
    'hasRothIRA',
    'hasTransferEligibleAccounts',
    'emergencyFundBalance',
    'hasSufficientEmergencyFund',
    'highInterestDebtBalance',
    'isFreeOfHighInterestDebt',
    'hasPreventionFromInvestingImmediately',
    'preventionReason',
    'preventionAdditionalDetails',
    'isEligibleNowToInvestImmediately',
    'preventionReason',
    'preventionAdditionalDetails',
    'willSendOpeningTasksAfterMeeting',
    'notSendingOpeningTasksReason',
    'openingTasksAdditionalDetails',
  ], {
    hidden: true,
  }, overrideReadOnly);
